/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostDataFilters } from '../models/CostDataFilters';
import { CostDataGroupBy } from '../models/CostDataGroupBy';
import { CostGranularity } from '../models/CostGranularity';
import { CostUnit } from '../models/CostUnit';
import { TimeFrame } from '../models/TimeFrame';

export class ExportCostDataRequest {
  'costUnit'?: CostUnit;
  'timeFrame': TimeFrame;
  'granularity'?: CostGranularity;
  'filters'?: CostDataFilters;
  'groupBy'?: CostDataGroupBy;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "costUnit",
      "baseName": "costUnit",
      "type": "CostUnit",
      "format": ""
    },
    {
      "name": "timeFrame",
      "baseName": "timeFrame",
      "type": "TimeFrame",
      "format": ""
    },
    {
      "name": "granularity",
      "baseName": "granularity",
      "type": "CostGranularity",
      "format": ""
    },
    {
      "name": "filters",
      "baseName": "filters",
      "type": "CostDataFilters",
      "format": ""
    },
    {
      "name": "groupBy",
      "baseName": "groupBy",
      "type": "CostDataGroupBy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ExportCostDataRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



